module.exports = __webpack_public_path__ + "static/media/ab7.0f594675.png";